import List from './List';

export { List };



// WEBPACK FOOTER //
// ./src/components/CaseStudiesPage/components/index.js